/* ==========================================================================
  main.js
========================================================================== */

'use strict';
/* global fitvids, cssVars */

/**
 * Init responsive videos
 */
fitvids();

/**
 * Init CSS vars ponyfill
 */
cssVars({});

/**
 * Top padding for the content because we have a fixed header
 */
/*
const siteHeader = document.querySelector('.site-header');
const siteBody = document.querySelector('.site-content');
const mobileNav = document.querySelector('.mobile-menu__nav');
let siteHeaderHeight;

document.addEventListener('DOMContentLoaded', () => {
  siteHeaderHeight = siteHeader.offsetHeight;
  siteBody.style.paddingTop = `${siteHeaderHeight}px`;
  //mobileNav.style.paddingTop = `${siteHeaderHeight}px`;
});

addEventListener('resize', (event) => {
  siteHeaderHeight = siteHeader.offsetHeight;
  siteBody.style.paddingTop = `${siteHeaderHeight}px`;
  //mobileNav.style.paddingTop = `${siteHeaderHeight}px`;
});
*/
